export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      industries: "Industries",
      contact: "Contact"
    },
    // Home Page
    home: {
      hero: {
        title: "From Nature to Your Table with Trust",
        subtitle: "Delivering natural, healthy, and delicious foods to the world with care, precision, and unwavering commitment to freshness and sustainability",
        cta: "Discover Our Journey",
        learnMore: "Learn More"
      },
      stats: {
        yearsExperience: "Years of Trust",
        countries: "Global Destinations",
        partners: "Trusted Partners",
        products: "Fresh Products"
      },
      whyChoose: {
        title: "Why Trust Henyex",
        subtitle: "Building trust through every delivery, from nature to your table",
        quality: {
          title: "Freshness & Hygiene",
          description: "Every step prioritizes freshness and hygiene, from careful selection to precise packaging, ensuring nature's best reaches you safely"
        },
        global: {
          title: "Global Trust Network",
          description: "Delivering health and pleasure to the most in-demand destinations worldwide with transparency and consistency"
        },
        reliable: {
          title: "Unwavering Reliability",
          description: "Standing behind every promise we make, rebuilding trust with every delivery through care and precision"
        },
        expert: {
          title: "Nature Meets Technology",
          description: "Balancing nature's valuable products with modern technology and human effort to deliver excellence"
        }
      }
    },
    // About Page
    about: {
      hero: {
        title: "About Henyex",
        subtitle: "Where trust meets every step from nature to table"
      },
      mission: {
        title: "Our Mission",
        description: "At HENYEX, we believe that trust is the most essential value in the food journey. Guided by this belief, we manage every step from nature to the table with great care, precision, and high-quality standards. From production and selection to packaging and logistics, we prioritize freshness, hygiene, and sustainability in every process. We see it as our duty to safely deliver natural, healthy, and delicious foods to the most in-demand destinations around the world. By standing behind every promise we make, we act with transparency and consistency, rebuilding trust with every delivery."
      },
      vision: {
        title: "Our Vision",
        description: "To bring together the most valuable products offered by nature with the delicate balance of modern technology and human effort, and to deliver health, pleasure, and trust to tables around the world."
      },
      values: {
        title: "Our Core Values",
        integrity: "Trust & Transparency",
        integrityDesc: "Trust is our foundation. We maintain complete transparency in every process, standing behind every promise we make",
        excellence: "Freshness & Quality",
        excellenceDesc: "Uncompromising commitment to freshness, hygiene, and the highest quality standards from nature to table",
        innovation: "Sustainability",
        innovationDesc: "Protecting nature while serving humanity, prioritizing sustainable practices in every step of our journey",
        partnership: "Care & Precision",
        partnershipDesc: "Managing every detail with great care and precision, ensuring natural and healthy foods reach you safely"
      }
    },
    // Services Page
    services: {
      hero: {
        title: "Our Services",
        subtitle: "Complete care from nature to table, ensuring freshness, hygiene, and trust"
      },
      import: {
        title: "Global Sourcing",
        description: "Carefully selecting the most valuable natural products from around the world, managing every step with precision to ensure freshness and hygiene reach your table"
      },
      export: {
        title: "International Distribution",
        description: "Delivering nature's treasures to the most in-demand global destinations with unwavering commitment to quality, sustainability, and trust"
      },
      distribution: {
        title: "Fresh Logistics",
        description: "Advanced cold chain and logistics solutions ensuring every product maintains its natural freshness and hygiene from our hands to yours"
      },
      consulting: {
        title: "Trust Advisory",
        description: "Transparent guidance on quality standards, sustainability practices, and market opportunities in the natural food sector"
      },
      quality: {
        title: "Hygiene & Quality Control",
        description: "Rigorous quality assurance at every stage—from selection and packaging to delivery—ensuring only the freshest, healthiest products reach you"
      },
      logistics: {
        title: "Nature-to-Table Solutions",
        description: "Comprehensive supply chain management balancing modern technology with human care, preserving freshness and natural quality throughout the journey"
      }
    },
    // Industries Page
    industries: {
      hero: {
        title: "Industries We Serve",
        subtitle: "Delivering natural freshness and trust to every sector"
      },
      retail: {
        title: "Retail & Supermarkets",
        description: "Bringing nature's freshest and healthiest products to retail shelves with guaranteed hygiene and sustainability at every step"
      },
      hospitality: {
        title: "Hospitality & Restaurants",
        description: "Supplying hotels and restaurants with premium natural ingredients that touch both palate and soul with freshness and flavor"
      },
      manufacturing: {
        title: "Food Manufacturing",
        description: "Providing natural, high-quality raw materials with complete transparency and traceability for food processors who value trust"
      },
      wholesale: {
        title: "Wholesale Distributors",
        description: "Partnering with distributors to deliver fresh, sustainable products with consistent quality and reliability they can trust"
      }
    },
    // Contact Page
    contact: {
      hero: {
        title: "Contact Us",
        subtitle: "Let's build a partnership based on trust and transparency"
      },
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        company: "Company Name",
        message: "Your Message",
        submit: "Send Message",
        sending: "Sending...",
        success: "Thank you! We'll get back to you soon.",
        error: "Something went wrong. Please try again."
      },
      info: {
        title: "Get In Touch",
        description: "Discover how we can deliver natural, fresh, and trusted products to your business. We're here to answer your questions with transparency and care.",
        address: "Address",
        addressValue: "Istanbul, Turkey",
        email: "Email",
        emailValue: "info@henyex.com",
        phone: "Phone",
        phoneValue: "0212 365 55 06"
      }
    },
    // Footer
    footer: {
      description: "Delivering health, pleasure, and trust from nature to tables worldwide. Your partner in fresh, natural, and sustainable food solutions.",
      quickLinks: "Quick Links",
      contact: "Contact Info",
      rights: "All rights reserved."
    }
  },
  tr: {
    // Navigation
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      services: "Hizmetler",
      industries: "Sektörler",
      contact: "İletişim"
    },
    // Home Page
    home: {
      hero: {
        title: "Doğadan Sofranıza Güvenle",
        subtitle: "Doğal, sağlıklı ve lezzetli gıdaları tüm dünyaya özen, hassasiyet ve tazeliğe olan sarsılmaz bağlılıkla ulaştırıyoruz",
        cta: "Yolculuğumuzu Keşfedin",
        learnMore: "Daha Fazla Bilgi"
      },
      stats: {
        yearsExperience: "Yıllık Güven",
        countries: "Küresel Destinasyon",
        partners: "Güvenilen Ortak",
        products: "Taze Ürün"
      },
      whyChoose: {
        title: "Neden Henyex'e Güvenmelisiniz",
        subtitle: "Doğadan sofranıza her teslimatla güven inşa ediyoruz",
        quality: {
          title: "Tazelik & Hijyen",
          description: "Özenli seçimden hassas paketlemeye her adım tazelik ve hijyeni önceliklendirir, doğanın en iyisinin size güvenle ulaşmasını sağlar"
        },
        global: {
          title: "Küresel Güven Ağı",
          description: "Şeffaflık ve tutarlılıkla dünya çapında en çok talep gören destinasyonlara sağlık ve lezzet sunuyoruz"
        },
        reliable: {
          title: "Sarsılmaz Güvenilirlik",
          description: "Verdiğimiz her sözün arkasında durarak, özen ve hassasiyetle her teslimatla güveni yeniden inşa ediyoruz"
        },
        expert: {
          title: "Doğa Teknoloji ile Buluşuyor",
          description: "Doğanın değerli ürünlerini modern teknoloji ve insan çabasıyla dengeleyerek mükemmelliği sunuyoruz"
        }
      }
    },
    // About Page
    about: {
      hero: {
        title: "Hakkımızda",
        subtitle: "Güvenin doğadan sofraya her adımda buluştuğu yer"
      },
      mission: {
        title: "Misyonumuz",
        description: "HENYEX olarak Güvenilirliğin gıda yolculuğundaki en temel değer olduğuna inanıyoruz. Bu inançla; doğadan sofralara uzanan her adımı ilmek ilmek, titizlikle ve yüksek kalite standartlarıyla yönetiyoruz. Üretimden seçime, paketlemeden lojistiğe kadar tüm süreçlerde tazeliği, hijyeni ve sürdürülebilirliği önceliğimiz kabul ediyoruz.\n\nSadece ağza değil, ruhunuza da dokunan; doğallığı hissedilen, sağlıklı ve lezzetli gıdaları dünyanın talep edilen noktalarına güvenle ulaştırmayı görev biliyoruz. İş ortaklarımıza ve tüketicilerimize verdiğimiz her sözün arkasında durarak, şeffaflık ve süreklilik ilkeleriyle hareket ediyor; her teslimatta güveni yeniden inşa ediyoruz.\n\nAmacımız; doğanın sunduğu en değerli ürünleri, modern teknoloji ve insan emeğinin hassas dengesiyle buluşturarak, global sofralara sağlık, keyif ve güven taşımaktır."
      },
      vision: {
        title: "Vizyonumuz",
        description: "Doğanın sunduğu en değerli ürünleri modern teknoloji ve insan emeğinin hassas dengesiyle bir araya getirerek, dünya çapındaki sofralara sağlık, lezzet ve güven taşımak."
      },
      values: {
        title: "Temel Değerlerimiz",
        integrity: "Güven & Şeffaflık",
        integrityDesc: "Güven temelimizdir. Her süreçte tam şeffaflık sağlıyor, verdiğimiz her sözün arkasında duruyoruz",
        excellence: "Tazelik & Kalite",
        excellenceDesc: "Doğadan sofraya tazelik, hijyen ve en yüksek kalite standartlarına taviz vermeden bağlılık",
        innovation: "Sürdürülebilirlik",
        innovationDesc: "İnsanlığa hizmet ederken doğayı koruyoruz, yolculuğumuzun her adımında sürdürülebilir uygulamaları önceliklendiriyoruz",
        partnership: "Özen & Hassasiyet",
        partnershipDesc: "Her detayı büyük bir özen ve hassasiyetle yöneterek, doğal ve sağlıklı gıdaların size güvenle ulaşmasını sağlıyoruz"
      }
    },
    // Services Page
    services: {
      hero: {
        title: "Hizmetlerimiz",
        subtitle: "Doğadan sofraya eksiksiz özen, tazelik, hijyen ve güven sağlıyoruz"
      },
      import: {
        title: "Küresel Tedarik",
        description: "Dünyanın dört bir yanından en değerli doğal ürünleri özenle seçiyor, tazelik ve hijyenin sofranıza ulaşması için her adımı hassasiyetle yönetiyoruz"
      },
      export: {
        title: "Uluslararası Dağıtım",
        description: "Doğanın hazinelerini kalite, sürdürülebilirlik ve güvene olan sarsılmaz bağlılıkla dünyanın en çok talep gören destinasyonlarına ulaştırıyoruz"
      },
      distribution: {
        title: "Taze Lojistik",
        description: "Gelişmiş soğuk zincir ve lojistik çözümleriyle her ürünün doğal tazeliğini ve hijyenini bizden size kadar korumasını sağlıyoruz"
      },
      consulting: {
        title: "Güven Danışmanlığı",
        description: "Doğal gıda sektöründe kalite standartları, sürdürülebilirlik uygulamaları ve pazar fırsatları konusunda şeffaf rehberlik"
      },
      quality: {
        title: "Hijyen & Kalite Kontrolü",
        description: "Seçimden paketlemeye, teslimat zamanına kadar her aşamada titiz kalite güvencesi—size yalnızca en taze, en sağlıklı ürünler ulaşır"
      },
      logistics: {
        title: "Doğadan Sofraya Çözümler",
        description: "Modern teknolojiyi insan özenle dengeleyen kapsamlı tedarik zinciri yönetimi, yolculuk boyunca tazeliği ve doğal kaliteyi korur"
      }
    },
    // Industries Page
    industries: {
      hero: {
        title: "Hizmet Verdiğimiz Sektörler",
        subtitle: "Her sektöre doğal tazelik ve güven sunuyoruz"
      },
      retail: {
        title: "Perakende ve Süpermarketler",
        description: "Doğanın en taze ve sağlıklı ürünlerini her adımda garantili hijyen ve sürdürülebilirlikle perakende raflarına getiriyoruz"
      },
      hospitality: {
        title: "Konaklama ve Restoranlar",
        description: "Otellere ve restoranlara tazelik ve lezzetle damağa değil ruha dokunan birinci sınıf doğal malzemeler sağlıyoruz"
      },
      manufacturing: {
        title: "Gıda İmalatı",
        description: "Güvene değer veren gıda işleyicileri için tam şeffaflık ve izlenebilirlikle doğal, yüksek kaliteli hammaddeler sunuyoruz"
      },
      wholesale: {
        title: "Toptan Dağıtıcılar",
        description: "Dağıtıcılarla ortaklık kurarak güvenebilecekleri tutarlı kalite ve güvenilirlikle taze, sürdürülebilir ürünler ulaştırıyoruz"
      }
    },
    // Contact Page
    contact: {
      hero: {
        title: "İletişim",
        subtitle: "Güven ve şeffaflığa dayalı bir ortaklık kuralım"
      },
      form: {
        name: "Ad Soyad",
        email: "E-posta Adresi",
        phone: "Telefon Numarası",
        company: "Şirket Adı",
        message: "Mesajınız",
        submit: "Mesaj Gönder",
        sending: "Gönderiliyor...",
        success: "Teşekkürler! En kısa sürede size dönüş yapacağız.",
        error: "Bir şeyler yanlış gitti. Lütfen tekrar deneyin."
      },
      info: {
        title: "Bize Ulaşın",
        description: "İşinize doğal, taze ve güvenilir ürünleri nasıl ulaştırabileceğimizi keşfedin. Sorularınızı şeffaflık ve özenle yanıtlamak için buradayız.",
        address: "Adres",
        addressValue: "İstanbul, Türkiye",
        email: "E-posta",
        emailValue: "info@henyex.com",
        phone: "Telefon",
        phoneValue: "0212 365 55 06"
      }
    },
    // Footer
    footer: {
      description: "Doğadan dünya çapındaki sofralara sağlık, lezzet ve güven ulaştırıyoruz. Taze, doğal ve sürdürülebilir gıda çözümlerinde ortağınız.",
      quickLinks: "Hızlı Bağlantılar",
      contact: "İletişim Bilgileri",
      rights: "Tüm hakları saklıdır."
    }
  }
};
